export default "__VITE_ASSET__DkmCMJoG__"